import { useNavigate } from 'react-router-dom';
import './rescheduleBooking.css';

const RescheduleBooking = ({ setShowRescheduleModal, data, type }) => {
    const navigate = useNavigate();

    const handleClose = (e) => {
        e.stopPropagation();
        setShowRescheduleModal(false);
    };
    const handleReschedule = (event) => {
        event.stopPropagation();
        let url = '';
        if (type === 'trip') {
            url = `/trip/details/${data?.packId?._id}`;
        } else if (type === 'act') {
            url = `/act/details/${data?.actId?._id}`;
        } else if (type === 'gu') {
            url = `/gu/details/${data?.guTourId?._id}`;
        }
        sessionStorage.setItem('confirmedBookingData', JSON.stringify(data));
        navigate(url);
    };
    return (
        <div className='modal'>
            <div className='modal-content'>
                <div onClick={(e) => e.stopPropagation()}>
                    <p className='modal-title'>Do you want to reschedule the booking?</p>
                    <button onClick={handleReschedule} className='confirm-btn'>
                        Yes
                    </button>
                    <button onClick={(e) => handleClose(e)} className='cancel-btn'>
                        No
                    </button>
                </div>
                {/* <div onClick={(e) => e.stopPropagation()}>
                    <p className='modal-title'>Do you want to change to a different trip?</p>
                    <button onClick={handleReschedule} className='confirm-btn'>
                        Yes
                    </button>
                    <button onClick={(e) => handleClose(e)} className='cancel-btn'>
                        No
                    </button>
                </div> */}
            </div>
        </div>
    );
};

export default RescheduleBooking;
